import React, { useState, useEffect } from 'react';
import { Modal, Button, Select } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import { stocks } from "../../devdata/maps/chartred";
import { Statescontex } from "../../context/index.js";
const { Option } = Select


const Algotest = ({ userdetails, recordit }) => {
    const [showATmodel, setshowATmodel] = useState(false);
    const [showATbImodel, setshowATbImodel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ATbrokerid, setATbroker] = useState(null);
    const [ATstock, setATstock] = useState("NIFTY");
    const { setErrorshow, setErrorMessage } = Statescontex();

    const navigate = useNavigate();
    const handleAlgotestClick = (record) => {
        if (userdetails.algoTestAT !== undefined && userdetails.algoTestAT !== "") {
            const found = stocks.find((stock) => stock.nsecode === record.nsecode);
            setATstock(found?.atToken)
            setshowATbImodel(true)
        } else {
            navigate("/Profile"); // 👈 Use path as defined in your router
            setErrorMessage("m_Please set the access token through profile")
            setErrorshow(true)
        }
    };
    useEffect(() => {
        if (recordit?.nsecode !== undefined) {
            handleAlgotestClick(recordit)
        }
    }, [recordit])

    return (
        <div>
            <Modal
                title={<span className="text-darkMode-text">Automate with Algotest</span>}
                centered
                open={showATmodel}
                onCancel={() => setshowATmodel(false)}
                confirmLoading={loading}
                className="rounded-xl shadow-lg text-darkMode-text"
                contentClassName="bg-darkMode-layer2 rounded-md p-6"
                footer={null}
                width={"90%"}
            >
                <div className="w-full h-[87vh]">
                    <iframe
                        src={`https://algotest.in/widget/marketpulse?accesstoken=${userdetails?.algoTestAT}&broker=${ATbrokerid}&underlying=${ATstock}`}
                        className="w-full h-full border-none rounded-md"
                        loading="lazy"
                    />
                </div>
            </Modal>

            <Modal
                title={<span className="text-xl font-bold text-darkMode-text">Select a Broker</span>}
                centered
                open={showATbImodel}
                onCancel={() => setshowATbImodel(false)}
                footer={null}
                className="rounded-2xl shadow-xl text-darkMode-text"
                contentClassName="bg-darkMode-layer2 rounded-xl p-6"
            >
                <div className="space-y-6">
                    {/* Broker Select Dropdown */}
                    <Select
                        showSearch
                        placeholder="Choose a broker"
                        value={ATbrokerid ?? ""}
                        onChange={(value) => setATbroker(value)}
                        optionLabelProp="label"
                        className="w-full"
                        dropdownClassName="rounded-xl bg-darkMode-layer3 text-darkMode-text"
                    >
                        {userdetails?.brokerIds?.map((broker) => (
                            <Option
                                key={broker.bId}
                                value={broker.bId}
                                label={broker.bName}
                                className="p-3"
                            >
                                <div className="flex flex-col">
                                    <span className="font-medium">{broker.bName}</span>
                                    <span className="text-xs text-darkMode-text/60">{broker.bId}</span>
                                </div>
                            </Option>
                        ))}

                        {/* Paper Trade Option */}
                        <Option key="paper" value="" label="Paper Trade">
                            <div className="flex flex-col">
                                <span className="font-medium">Paper Trade</span>
                                <span className="text-xs text-darkMode-text/60">Use without a broker</span>
                            </div>
                        </Option>
                    </Select>

                    {/* Profile Setup Prompt */}
                    {(!userdetails?.brokerIds?.length || userdetails.brokerIds.length === 0) && (
                        <Link to="/Profile">
                            <div className="p-4 rounded-xl border border-darkMode-layer3 text-center transition-all hover:border-darkMode-green hover:bg-darkMode-layer3/50 cursor-pointer">
                                <span className="text-sm font-semibold text-darkMode-green">
                                    Set Broker ID from Profile
                                </span>
                            </div>
                        </Link>
                    )}

                    {/* Continue Button */}
                    <Button
                        type="primary"
                        className="w-full mt-2 bg-darkMode-green border-none text-white font-semibold py-2 rounded-lg hover:opacity-90"
                        disabled={ATbrokerid === undefined}
                        onClick={() => {
                            setshowATbImodel(false);
                            setshowATmodel(true);
                        }}
                    >
                        Continue
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default Algotest;
